export default {
	title: "",
	subtitle: "Confirm 3DS for BRL Card Subscription",
  path: "subscription_brl_card_3ds_challenge_confirmation",
  paragraph: 'Basically, using the subscription with a card is very similar to the "Credit card transactions Brazil" and "Credit card transactions Brazil - JWT for DDC" sections.',
  request: {
    method: "POST",
		endpoint: "/subscriptions/:id/threeds_challenge",
		payload: {
      "credit_card": {
        "card_brand": "Visa",
        "card_expiration_date": "09/2029",
        "card_number": "4000000000001000",
        "card_security_code": "123",
        "fullname": "Jose Silva"
      }
    },
		responses: {
      "data": {
        "canceled_at": null,
        "canceled_by_payer": null,
        "canceled_reason": null,
        "completed_at": null,
        "currency": "BRL",
        "cycles": 12,
        "description": "some description",
        "free_days": 0,
        "frequency": "month",
        "from_bank_account_id": null,
        "id": "86c142b7-9b94-413d-9894-74c35835f666",
        "inserted_at": "2025-09-12T21:00:54.680247",
        "payer_bank_account_id": null,
        "payer_card_id": "2241cdcd-bc2c-4361-8079-435b322e6f1f",
        "payment_method": "card",
        "status": "active",
        "subject_id": "2c90ad60-31de-4624-a852-60960a814e2c",
        "to_bank_account_id": "504fc315-ce61-4179-b19a-e4617eaae30f",
        "total_retry_attempts": 0,
        "trial_days": 0,
        "updated_at": "2025-09-12T21:00:54.783049",
        "value": "100"
      }
    }
	},
  pathPayload: [
    {
      name: "id",
      type: "string",
      required: true,
      description: "Subscription ID"
    }
  ],
	parameterPayload: [
    {
      name: "credit_card",
      type: "object",
      required: true,
      description: ""
    },
    {
      name: "credit_card.card_number",
      type: "string",
      required: true,
      description: "The card number without spaces"
    },
    {
      name: "credit_card.card_expiration_date",
      type: "string",
      required: true,
      description: "Card expiration date in MM/YYYY format"
    },
    {
      name: "credit_card.card_brand",
      type: "string",
      required: true,
      description: 'Card brand, such as "visa", "mastercard", or "elo"'
    },
    {
      name: "credit_card.card_security_code",
      type: "string",
      required: true,
			description: "3-digit card security code"
    },
    {
      name: "credit_card.fullname",
      type: "string",
      required: true,
      description: "Cardholder's full name"
    },
  ],
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Subscription/SubscriptionBRLCardConfirmation.js